import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BASE_URL, PagedResponse } from "@edl-development/edl-common";
import { PagedModel } from "src/app/model/common/paged.model";
import { ComplyBaseApi } from "../comply/comply-base.api";
import { EdlPubSubLogSummaryDTO } from "src/app/model/edl-pub-sub-log/edl-pub-sub-log-summary-dto.model";
import { EdlPubSubLogFilters } from "src/app/model/edl-pub-sub-log/edl-pub-sub-log-filters.model";

@Injectable()
export class EdlPubSubLogApi extends ComplyBaseApi {
    private static SUB_ROUTE = 'edlPubSubLog';

    private get route() {
        return `${this.baseUri}/${EdlPubSubLogApi.SUB_ROUTE}`;
    }

    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getLogs(paging: PagedModel, filters: EdlPubSubLogFilters) {
        let params = this.generatePagingParams(paging);

        if (filters.followupActionsOnly) {
            params = params.append('followupActionsOnly', String(filters.followupActionsOnly));
        }

        if (filters.startTime) {
            params = params.append('startTime', filters.startTime.toISOString());
        }

        if (filters.endTime) {
            params = params.append('endTime', filters.endTime.toISOString());
        }

        return this.http.get<PagedResponse<EdlPubSubLogSummaryDTO>>(`${this.route}`, {
            params
        });
    }

    undoAction(logId: string) {
        return this.http.put(`${this.route}/UndoAction/${logId}`, {});
    }
}